import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

let client: SupabaseClient | null = null;

// Custom lock tránh deadlock do navigator.locks bị kẹt ở tab khác
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customLock = async (_name: string, _acquireTimeout: number, fn: () => Promise<any>): Promise<any> => {
  return fn();
};

export function getSupabase(): SupabaseClient {
  if (!client) {
    client = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        lock: customLock as never,
      },
    });
  }
  return client;
}

export const supabase = getSupabase();